import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator", "tab", "trigger"]
  static classes = ["active"]

  connect() {
    // if there's no active element, mark the first as active
    let activeTab = this.tabTargets.find(target => target.classList.contains(this.activeClass))
    if (!activeTab) {
      this.tabTargets[0].classList.add("active")
      if (this.hasTriggerTarget) {
        this.triggerTargets[0]?.setAttribute("aria-selected", "true")
      }
    } else {
      // Set aria-selected on the corresponding trigger
      const activeIndex = this.tabTargets.indexOf(activeTab)
      if (this.hasTriggerTarget && this.triggerTargets[activeIndex]) {
        this.triggerTargets[activeIndex].setAttribute("aria-selected", "true")
      }
    }
  }

  open(event) {
    let targetId = event.currentTarget.dataset.targetId
    let selectedIndex = this.tabTargets.findIndex(element => element.id === targetId)
    let selected = this.tabTargets[selectedIndex]
    let other = this.tabTargets.filter(element => element.id !== targetId)

    selected.classList.add(this.activeClass)
    other.forEach(element => element.classList.remove(this.activeClass))
    
    // Update ARIA attributes on triggers
    if (this.hasTriggerTarget) {
      this.triggerTargets.forEach((trigger, index) => {
        trigger.setAttribute("aria-selected", index === selectedIndex ? "true" : "false")
      })
    }
    
    if (this.indicatorTarget) {
      this.indicatorTarget.style.left = `${event.currentTarget.offsetWidth * selectedIndex}px`
    }
  }

  // Keyboard navigation for tabs (Arrow keys, Home, End)
  handleKeydown(event) {
    const currentIndex = this.triggerTargets.indexOf(event.currentTarget)
    let nextIndex

    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        event.preventDefault()
        nextIndex = (currentIndex + 1) % this.triggerTargets.length
        break
      case "ArrowLeft":
      case "ArrowUp":
        event.preventDefault()
        nextIndex = currentIndex - 1 < 0 ? this.triggerTargets.length - 1 : currentIndex - 1
        break
      case "Home":
        event.preventDefault()
        nextIndex = 0
        break
      case "End":
        event.preventDefault()
        nextIndex = this.triggerTargets.length - 1
        break
      default:
        return
    }

    if (nextIndex !== undefined) {
      this.triggerTargets[nextIndex].click()
      this.triggerTargets[nextIndex].focus()
    }
  }
}
